import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="pp-dark py-12 text-sm" style={{ color: "#B9A48C" }} data-testid="site-footer">
    <div className="pp-container grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
      <div className="text-center md:text-left">
        <div className="font-serif-display text-2xl" style={{ color: "var(--pp-parchment)" }}>
          Pumpkin <span className="italic font-light">&amp;</span> Porch
        </div>
        <div className="mt-1">Seasonal porch styling, by hand · Salt Lake to Payson · Autumn 2026</div>
        <Link to="/care" data-testid="footer-care-link" className="inline-block mt-2 underline underline-offset-4 hover:opacity-70" style={{ color: "var(--pp-parchment)" }}>Care for your setup →</Link>
      </div>
      <div className="flex justify-center">
        <img src="/logo-light.png" alt="Pumpkin & Porch logo" data-testid="footer-logo" className="h-20 w-20 object-contain" />
      </div>
      <div className="text-center md:text-right" data-testid="footer-contact">
        <div className="pp-caption mb-2">Contact us</div>
        <a href="tel:+18016025001" data-testid="footer-contact-phone" className="block underline underline-offset-4 hover:opacity-70 mb-1" style={{ color: "var(--pp-parchment)" }}>
          801-602-5001
        </a>
        <a href="mailto:pumpkinandporchhelp@gmail.com" data-testid="footer-contact-email" className="underline underline-offset-4 hover:opacity-70" style={{ color: "var(--pp-parchment)" }}>
          pumpkinandporchhelp@gmail.com
        </a>
        <div className="mt-1 text-xs">Questions, quotes or a change of date — we answer personally.</div>
      </div>
    </div>
  </footer>
);
